import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'


if (typeof window !== 'undefined') {

  if (typeof ResizeObserver !== 'undefined') {
    const originalResizeObserver = ResizeObserver
    window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          requestAnimationFrame(() => {
            try {
              callback(entries, observer)
            } catch (error) {
              // 忽略错误
              console.log('ResizeObserver error:', error)
            }
          })
        })
      }
    }
  }
  

  window.addEventListener('error', function(event) {
    if (event.message && event.message.includes('ResizeObserver loop')) {
      event.preventDefault()
      event.stopPropagation()
      console.log('ResizeObserver loop error caught and ignored')
    }
  }, true)
}
console.log('v1.0.0')
const app = createApp(App)
import 'element-plus/dist/index.css'
app.use(store)
app.use(router)
app.use(ElementPlus, { zIndex: 3000 })
app.mount('#app')
